module.exports = __webpack_public_path__ + "static/media/Grupo1683.17f28d99.svg";